import { render, staticRenderFns } from "./gl-row-wrapper.vue?vue&type=template&id=2d6dc47e&scoped=true"
import script from "./gl-row-wrapper.vue?vue&type=script&lang=js"
export * from "./gl-row-wrapper.vue?vue&type=script&lang=js"
import style0 from "./gl-row-wrapper.vue?vue&type=style&index=0&id=2d6dc47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6dc47e",
  null
  
)

export default component.exports